import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { ChallengesMilestoneDataService } from "src/app/core/services/challenges-milestone-data.service";
import { Globals } from "src/app/core/services/global.service";

@Component({
  selector: "app-create-new-challenge-details",
  templateUrl: "./create-new-challenge-details.component.html",
  styleUrls: ["./create-new-challenge-details.component.css"],
})
export class CreateNewChallengeDetailsComponent implements OnInit {
  selectedChallenge = "";
  progressType = "typeselection";
  isEdit = false;
  id;
  isNew = false;
  duplicateNameErrorText = "";
  status;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _apiCall: ApiCallService,
    private tokenStorage: TokenStorageService,
    private global: Globals,
    private challengesMilestoneDataService: ChallengesMilestoneDataService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params["action"] === "edit" || params['action'] === "new") {
        this.isEdit = true;
        this.isNew = params['action'] === "new" ? true : false;
        this.progressType = "challengedetails";
        if (params["id"]) {
          this.id = params["id"];
          if (!this.challengesMilestoneDataService.getChallengeDetails()) {
            this.getChallengeDetailsApi(this.id).then((res) => {
              this.challengesMilestoneDataService.setChallengeDetails(
                res["body"]
              );
              let data: any = res["body"];
              data.scheduledStartTime = this.formatTimestamp(data["executionDate"], 'start');
              data.scheduledEndTime = this.formatTimestamp(data["scheduleEndDate"], 'end');
              this.selectedChallenge = data["challengeType"] ? data["challengeType"] : "MILESTONE_BASED_CHALLENGE";
              this.challengesMilestoneDataService.setChallengeDetails(data);
              this.challengesMilestoneDataService.setMilestoneConfig(this.global.safeParse(data['displayParams']));
              console.log("data", data);
            });
          } else {
            let data: any = this.challengesMilestoneDataService.getChallengeDetails();
            this.selectedChallenge = data["challengeType"] ? data["challengeType"] : "MILESTONE_BASED_CHALLENGE";
            console.log("data", data);
          }
        }
      }
      if(params['status']){
        this.status = params['status'];
      }
    });
  }

  formatTimestamp(timestamp: number, type: 'start' | 'end'): string {
    const merchantTimeZone = this.tokenStorage.getMerchantTimeZone();
  
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: merchantTimeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(timestamp);
  
    const dateParts: any = {};
    parts.forEach((part) => {
      if (part.type !== "literal") {
        dateParts[part.type] = part.value;
      }
    });
  
    const time = type === "start" ? "00:00:00" : "23:59:59";
  
    return `${dateParts.year}-${dateParts.month}-${dateParts.day} ${time}`;
  }
  

  challengeTypeData(value) {
    if (value === "exit") {
      this.challengesMilestoneDataService.resetAllData();
      this.router.navigate(["/app/challenges/"]);
      return;
    }
    this.selectedChallenge = value;
    this.progressType = "challengedetails";
  }

  challengeDetails(value) {
    if (value.value === "exit") {
      this.challengesMilestoneDataService.resetAllData();
      this.router.navigate(["/app/challenges/"]);
      return;
    }
    value.data.id = this.id ? this.id : null;
    value.data.challengeType = this.selectedChallenge;
    if (this.isEdit) {
      this.updateChallengeApi(value.data, this.id).then((response) => {
        this.challengesMilestoneDataService.setChallengeDetails(value.data);
        if(value.value === 'saveandexit'){
          this.router.navigate(["/app/challenges/"]);
          return;
        }
        if(!this.isNew){
          this.router.navigate(["/app/challenges/view-challenge"], {
            queryParams: {
              challengeId: this.id,
            },
          });
        } else{
          this.router.navigate(["/app/challenges/create-new-milestone"], {
            queryParams: {
              challengeId: this.id,
            },
          });
        }
      },(err)=>{
        this.duplicateNameErrorText = err.body;
      });
    }
    if (this.selectedChallenge === "MILESTONE_BASED_CHALLENGE" && !this.isEdit) {
      this.createNewChallengeApi(value.data).then((response) => {
        if (response) {
          this.challengesMilestoneDataService.setChallengeDetails(value.data);
          if(value.value === 'saveandexit'){
            this.router.navigate(["/app/challenges/"]);
            return;
          }
          this.router.navigate(["/app/challenges/create-new-milestone"], {
            queryParams: {
              challengeId: response["body"],
            },
          });
        }
      },(error)=>{
        this.duplicateNameErrorText = error.body;
      });
      return;
    }
  }
  createNewChallengeApi(data) {
    return new Promise((resolve, reject) => {
      this._apiCall.createChallenge(data).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);

          reject(err.error);
        }
      );
    });
  }

  updateChallengeApi(data, id) {
    return new Promise((resolve, reject) => {
      this._apiCall.updateChallenge(data, id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  getChallengeDetailsApi(id) {
    return new Promise((resolve, reject) => {
      this._apiCall.getChallengeDetails(id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }
}
